module.exports = __webpack_public_path__ + "img/academy-banner.bdf97916.png";